import { SERVICE_STATUS_LIST } from '@/consts/services'
import { USERS_STATUS_LIST } from '@/consts/users'
import { SITES_STATUS_LIST } from '@/consts/sites'
import { CUSTOMERS_STATUS_LIST } from '@/consts/customers'
import { COMMERCIAL_DOCS_STATUS_LIST } from '@/consts/commercialDocs'
import AutocompleteTypeMc from 'components/fields/AutocompleteTypeMc'
import SelectCustomerType from 'components/Select/SelectCustomerType'
import SelectExpirationType from 'components/Select/SelectExpirationType'
import SelectAgentType from 'components/Select/SelectAgentType'
import SelectUnavailabilityType from 'components/Select/SelectUnavailabilityType'
import LwfDatePicker from 'components/core/LwfDatePicker'
import LwfDateRangePicker from 'components/core/LwfDateRangePicker'
import AutocompleteSite from 'components/fields/AutocompleteSite'
import AutocompleteSpecialite from 'components/fields/AutocompleteSpecialite'
import _ from 'lodash'
import AutocompleteAgent from 'components/fields/AutocompleteAgent'
import AutocompleteClient from 'components/fields/AutocompleteClient'
import AutocompleteAgency from 'components/fields/AutocompleteAgency'
import { DEMANDES_STATUS_LIST } from '@/consts/data/demandes'
import { RATING_OPTIONS } from '@/consts/agents'
import { CONTRACT_STATUS_LIST } from '@/consts/data/contract'

export const FILTER_IS_OPTIONS_TYPE = 'is_options'
export const FILTER_ENTITY_TYPE = 'entity'
export const FILTER_DATE_TYPE = 'date'
export const FILTER_SELECT_TYPE = 'select'

export const defaultSelectProps = {
  'emit-value': true,
  'map-options': true,
  'use-chips': true,
  multiple: true,
  'hide-selected': false
}

export const availableFilters = {
  startAt: {
    component: LwfDatePicker,
    props: {
      label: 'Date début',
      hint: undefined
    }
  },
  endAt: {
    component: LwfDatePicker,
    props: {
      label: 'Date fin',
      hint: undefined
    }
  },
  dateRange: {
    component: LwfDateRangePicker,
    label: 'Intervalle',
    props: {
      hint: undefined,
      clearable: true
    }
  },
  agents: {
    label: 'Agents',
    component: AutocompleteAgent
  },
  agency: {
    label: 'Agences',
    component: AutocompleteAgency
  },
  sites: {
    label: 'Sites',
    component: AutocompleteSite,
    options: {
      field: 'slug',
      relation: 'site',
      multiple: true,
      type: FILTER_ENTITY_TYPE
    }
  },
  customers: {
    label: 'Clients',
    component: AutocompleteClient,
    options: {
      field: 'slug',
      relation: 'customer',
      multiple: true,
      type: FILTER_ENTITY_TYPE
    }
  },
  specialties: {
    label: `${_.upperFirst(process.env.APP.words.specialty)}s`,
    allLabel: 'Toutes',
    component: AutocompleteSpecialite,
    props: {
      clearable: true
    },
    options: {
      field: 'id',
      relation: 'specialties',
      subRelation: 'specialty',
      multiple: true,
      type: FILTER_ENTITY_TYPE
    }
  },
  agentSpecialties: {
    label: `${_.upperFirst(process.env.APP.words.specialty)}s`,
    allLabel: 'Toutes',
    component: AutocompleteSpecialite,
    props: {
      clearable: true
    },
    options: {
      field: 'id',
      relation: 'agentInfos.specialties',
      multiple: true,
      type: FILTER_ENTITY_TYPE
    }
  },
  customersStatus: {
    label: 'Statut',
    props: {
      options: CUSTOMERS_STATUS_LIST,
      optionLabel: 'label'
    },
    options: {
      field: 'status',
      type: FILTER_SELECT_TYPE
    }
  },
  usersStatus: {
    label: 'Statut',
    props: {
      options: USERS_STATUS_LIST,
      optionLabel: 'label'
    },
    options: {
      field: 'enabled',
      type: FILTER_SELECT_TYPE
    }
  },
  sitesStatus: {
    label: 'Statut',
    props: {
      options: SITES_STATUS_LIST,
      optionLabel: 'label'
    },
    options: {
      field: 'status',
      type: FILTER_SELECT_TYPE
    }
  },
  servicesStatus: {
    label: 'Statuts',
    key: 'status',
    props: {
      options: SERVICE_STATUS_LIST,
      optionLabel: 'label'
    }
  },
  estimatesStatus: {
    label: 'Statuts',
    key: 'status',
    props: {
      options: COMMERCIAL_DOCS_STATUS_LIST,
      optionLabel: 'label'
    }
  },
  invoicesStatus: {
    label: 'Statuts',
    key: 'status',
    props: {
      options: COMMERCIAL_DOCS_STATUS_LIST,
      optionLabel: 'label'
    }
  },
  contractStatus: {
    label: 'Statuts',
    key: 'status',
    props: {
      options: CONTRACT_STATUS_LIST,
      optionLabel: 'label'
    }
  },
  eventTypes: {
    key: 'eventTypes',
    label: 'Types de mains courantes',
    component: AutocompleteTypeMc,
    props: {
      ignore: true,
      optionValue: 'id',
      mainTypes: false
    }
  },
  expirationType: {
    key: 'expirationType',
    label: `Types d'expirations`,
    component: SelectExpirationType,
    options: {
      field: 'expirationType',
      type: FILTER_SELECT_TYPE
    }
  },
  customerType: {
    key: 'customerType',
    label: 'Types de clients',
    component: SelectCustomerType,
    options: {
      field: 'customerType',
      type: FILTER_SELECT_TYPE
    }
  },
  agentType: {
    key: 'type',
    label: 'Types d\'agents',
    component: SelectAgentType,
    options: {
      field: 'agentInfos.type',
      type: FILTER_SELECT_TYPE
    }
  },
  agentRating: {
    key: 'rating',
    label: 'notes',
    options: {
      field: 'rating',
      type: FILTER_SELECT_TYPE
    },
    props: {
      options: RATING_OPTIONS,
      'option-label': 'label',
      'option-value': 'value'
    }
  },
  unavailabilityType: {
    key: 'type',
    label: 'Types d\'indisponibilités',
    component: SelectUnavailabilityType,
    options: {
      field: 'type',
      type: FILTER_SELECT_TYPE
    }
  },
  requestStatus: {
    label: 'Statuts',
    key: 'status',
    props: {
      options: DEMANDES_STATUS_LIST,
      optionLabel: 'label',
      optionValue: 'value'
    }
  }
}

export function filterData (data, filters) {
  return _.filter(data, (v) => {
    let filterable = true
    Object.keys(filters).forEach((fKey) => {
      const currentFilter = availableFilters[fKey] ? availableFilters[fKey].options : null
      if (currentFilter) {
        if (filters[fKey] && filters[fKey].length) {
          switch (currentFilter.type) {
            case FILTER_SELECT_TYPE: {
              filterable = filters[fKey].includes(_.get(v, currentFilter.field))
              filterable = isFilterable(filters[fKey], _.get(v, currentFilter.field))
              break
            }
            case FILTER_IS_OPTIONS_TYPE: {
              // todo
              filterable = true
              break
            }
            case FILTER_DATE_TYPE: {
              // todo
              filterable = true
              break
            }
            case FILTER_ENTITY_TYPE: {
              const parent = _.get(v, currentFilter.parent)
              v = parent || v
              const relation = _.get(v, currentFilter.relation)
              if (relation) {
                if (currentFilter.multiple && currentFilter.subRelation) {
                  filterable = _.intersection(
                    relation.map((r) => r[currentFilter.subRelation][currentFilter.field]),
                    filters[fKey]
                  ).length > 0
                } else {
                  filterable = isFilterable(filters[fKey], _.get(relation, currentFilter.field))
                }
              } else {
                throw new Error(`La propriété ${currentFilter.relation} n'existe pas dans ces données`)
              }
              break
            }
          }
          if (!filterable) {
            return false
          }
        }
      } else {
        throw new Error(`Le filtre ${fKey} n'a pas d'options pour les données statiques`)
      }
    })
    return filterable
  })
}

function isFilterable (filter, field) {
  return filter.includes(field)
}
